import React from 'react';
import { Site } from '../../lib/Site';
import FooterLinksItem from '../FooterLinksMenu/FooterLinksItem';
import DesignServicesMenu from './DesignServicesMenu';

interface Props {
    site: Site;
}

export default function SiteFooterNavigationReduced({ site }: Props) {
    return (
        <div className="site-footer__navigation">
            <div className="site-footer__navigation__inner">
                <div className="site-footer__navigation__group">
                    <h5 className="heading heading--h6 heading--grey800">
                        {__('Design services')}
                    </h5>
                    <DesignServicesMenu site={site} reduced={true} />
                </div>
                <div className="site-footer__navigation__group">
                    <div className="footer-links-menu">
                        <h5 className="heading heading--h6 heading--grey800">{__('Support')}</h5>
                        <ul className="footer-links-menu__items">
                            <FooterLinksItem label={__('Help')} url="/help" />
                        </ul>
                    </div>
                </div>
                <div className="site-footer__navigation__group">
                    <div className="footer-links-menu">
                        <h5 className="heading heading--h6 heading--grey800">
                            {__('Resources')}
                        </h5>
                        <ul className="footer-links-menu__items">
                            <FooterLinksItem label={__('Pricing')} url="/pricing" />
                            <FooterLinksItem label={__('Become a designer')} url="/designers" />
                            <FooterLinksItem label={__('Blog')} url="/blog/" />
                            <FooterLinksItem label={'99awards'} url="/best-design-awards" />
                        </ul>
                    </div>
                </div>
                <div className="site-footer__navigation__group">
                    <div className="footer-links-menu">
                        <h5 className="heading heading--h6 heading--grey800">{__('Company')}</h5>
                        <ul className="footer-links-menu__items">
                            <FooterLinksItem label={__('About')} url="/about" />
                            <FooterLinksItem label={__('Contact')} url="/about/contact" />
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
